// Every `${prefix}.key` entry replaces the text of `key`, so a mode can ship
// its own wording for existing labels without touching the components.
export const applyTranslationOverlay = (
  messages: Record<string, string>,
  prefix: string
): Record<string, string> => {
  const keyStart = `${prefix}.`;
  const result = { ...messages };
  Object.keys(messages).forEach(key => {
    if (key.startsWith(keyStart)) {
      result[key.slice(keyStart.length)] = messages[key];
    }
  });
  return result;
};
